import React from 'react';
import Icon from '../../../components/AppIcon';

const HeroSection = ({ dealership }) => {
  const sectionStyle = dealership?.ciPrimaryColor ? {
    background: `linear-gradient(135deg, ${dealership?.ciPrimaryColor}60 0%, ${dealership?.ciSecondaryColor || dealership?.ciPrimaryColor}40 50%, transparent 100%)`
  } : {};

  const badgeStyle = dealership?.ciPrimaryColor ? {
    backgroundColor: `${dealership?.ciPrimaryColor}70`,
    color: '#ffffff',
    borderColor: dealership?.ciPrimaryColor,
    borderWidth: '3px',
    borderStyle: 'solid',
    fontWeight: '600'
  } : {};

  const iconColor = dealership?.ciPrimaryColor ? '#ffffff' : 'var(--color-success)';
  const partnerName = dealership?.name || 'Ihrem Partner';
  const voucherCurrency = dealership?.voucherCurrency || 'Euro';

  // Calculate total premium from per-year values, fall back to voucherValue
  const premium2026 = Number(dealership?.premium2026 ?? dealership?.voucherValue ?? 150);
  const premium2027 = Number(dealership?.premium2027 ?? 0);
  const totalPremium = premium2026 + premium2027;
  const has2027 = premium2027 > 0;

  return (
    <section className="bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-12 md:py-16" style={sectionStyle}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto space-y-6">
          <div 
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium"
            style={dealership?.ciPrimaryColor ? badgeStyle : { backgroundColor: 'var(--color-success-bg)', color: 'var(--color-success)' }}
          >
            <Icon name="Gift" size={18} color={iconColor} />
            Exklusiv für Elektroauto-Fahrer
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground leading-tight">
            Jetzt bis zu {totalPremium} {voucherCurrency} Gutschein für Ihr Elektroauto bei {partnerName} sichern
          </h2>
          
          <p className="text-lg text-muted-foreground leading-relaxed">
            {has2027
              ? `Wenn Sie Ihre THG-Quote direkt für 2026 und 2027 registrieren, erhalten Sie bis zu ${totalPremium} ${voucherCurrency} Gutschein – einlösbar bei ${partnerName}.`
              : `Registrieren Sie Ihre THG-Quote für 2026 und erhalten Sie ${premium2026} ${voucherCurrency} Gutschein – einlösbar bei ${partnerName}.`
            }
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-8">
            <div className="bg-card rounded-lg p-6 shadow-card hover:shadow-modal transition-smooth">
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
                style={dealership?.ciPrimaryColor ? { 
                  backgroundColor: dealership?.ciPrimaryColor,
                  borderColor: dealership?.ciPrimaryColor,
                  borderWidth: '3px',
                  borderStyle: 'solid'
                } : { backgroundColor: 'var(--color-primary-bg)' }}
              >
                <Icon name="Gift" size={24} color={dealership?.ciPrimaryColor ? '#ffffff' : 'var(--color-primary)'} />
              </div>
              <h3 className="font-heading font-semibold text-foreground mb-2">Bis zu {totalPremium} {voucherCurrency} Gutschein</h3>
              <p className="text-sm text-muted-foreground">Einlösbar bei {partnerName} – für Service, Wartung oder Zubehör.</p>
            </div>
            
            <div className="bg-card rounded-lg p-6 shadow-card hover:shadow-modal transition-smooth">
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
                style={dealership?.ciPrimaryColor ? { 
                  backgroundColor: dealership?.ciPrimaryColor,
                  borderColor: dealership?.ciPrimaryColor,
                  borderWidth: '3px',
                  borderStyle: 'solid'
                } : { backgroundColor: 'var(--color-primary-bg)' }}
              >
                <Icon name="CalendarCheck" size={24} color={dealership?.ciPrimaryColor ? '#ffffff' : 'var(--color-primary)'} />
              </div>
              <h3 className="font-heading font-semibold text-foreground mb-2">
                {has2027 ? '2026 & 2027 gleichzeitig' : '2026 jetzt registrieren'}
              </h3>
              <p className="text-sm text-muted-foreground">
                {has2027
                  ? 'Jetzt beide Jahre auf einmal registrieren und den vollen Vorteil sichern.'
                  : `${premium2026} ${voucherCurrency} Gutschein für Ihre THG-Quote 2026 sichern.`
                }
              </p>
            </div>
            
            <div className="bg-card rounded-lg p-6 shadow-card hover:shadow-modal transition-smooth">
              <div 
                className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
                style={dealership?.ciPrimaryColor ? { 
                  backgroundColor: dealership?.ciPrimaryColor,
                  borderColor: dealership?.ciPrimaryColor,
                  borderWidth: '3px',
                  borderStyle: 'solid'
                } : { backgroundColor: 'var(--color-primary-bg)' }}
              >
                <Icon name="CheckCircle2" size={24} color={dealership?.ciPrimaryColor ? '#ffffff' : 'var(--color-primary)'} />
              </div>
              <h3 className="font-heading font-semibold text-foreground mb-2">Alles für Sie erledigt</h3>
              <p className="text-sm text-muted-foreground">Formular ausfüllen, Fahrzeugschein hochladen – wir übernehmen den Rest.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;